import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import {hit} from '../../metrics';
import CaseFooter from '../CaseFooter';
import HelmetSite from '../HelmetSite';
import './style.css';

class Chateau extends Component {
  state = {
		preview: true,
		play: false,
		mobile: window.innerWidth <= 1000
	};

	resize = () => this.setState({mobile: window.innerWidth <= 1000});

  handleVideoPlay = () => {
    const video = document.querySelector('#chateau .video video');
    const section = document.querySelector('#chateau .section9');
    if (!video || !section) return;

    if (video.paused) {
      video.play();
      section.classList.add('is-playing');
    } else {
      video.pause();
      section.classList.remove('is-playing');
    }
  };

  handleVideoPause = () => {
    const video = document.querySelector('#chateau .video video');
    const section = document.querySelector('#chateau .section9');
    if (!video || !section) return;
    video.pause();
    section.classList.remove('is-playing');
  };

  handleVideoEnded = () => {
    const section = document.querySelector('#chateau .section9');
    if (section) section.classList.remove('is-playing');
  };

  componentDidMount() {
    const isMobile = this.state.mobile;
    const windowHeight = window.innerHeight;

    if(this.props.pathname === '/projects/chateau/'){
      this.setState({preview: false});
      this.props.setProjectName('chateau');
      $('body').addClass('case-expanded hash-chateau');
      $(window).scrollTop($('#chateau').offset().top);
      this.props.changeCase(null);
    }
    else{
      this.setState({preview: true});
      $('body').removeClass('hash-chateau');
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);
    
		window.gsap.registerPlugin(window.ScrollTrigger, window.ScrollSmoother);
    var smoother = window.ScrollSmoother.create({
      smooth: 2,
			effects: true,
			smoothTouch: false,
			normalizeScroll: true,
		});

		if(isMobile){
      smoother.kill();
    }

    console.log('scrollWidth', $('#chateau .section6 .wine-slider')[0].scrollWidth);
    console.log('clientWidth', $('#chateau .section6 .wine-slider')[0].clientWidth);
    

    const itemsWidth = $('#chateau .section6 .wine-slider')[0].scrollWidth;
    const containerWidth = $('#chateau .section6 .wine-slider')[0].clientWidth;
    const scrollDistance = isMobile
          ? windowHeight * 1.25
          : windowHeight * 2.5;

    const tl = window.gsap.timeline({
      scrollTrigger: {
        trigger: '#chateau .section6',
        start: `top 60%`,
        end: `+=${scrollDistance}`,
        scrub: true,
        invalidateOnRefresh: true
      }
    });
    tl.to('#chateau .section6 .wine-slider', {
      x: -(itemsWidth - containerWidth),
      duration: isMobile ? 1.2 : 0.6
    })

    setTimeout(() => {
      $('body').addClass('fadepage');
    }, 100);
  }

  componentDidUpdate() {
    if(this.props.pathname === '/projects/'){
      $('body').removeClass('case-expanded hash-chateau');
    }
  }
  
  componentWillUnmount() {
    $('body').removeClass('fadepage');
  }
  
  render(){
    return(
      <div className="case">
        <div className="case-content" id="chateau">
          <section className="section1">
            <div className="video" style={{backgroundImage: `url('/cases/img/chateau/top_poster.webp')`}}>
              {!this.state.mobile && (<video playsInline autoPlay poster="/cases/img/chateau/top_poster.webp" muted loop>
                <source src="/cases/img/chateau/top_video.mp4" type="video/mp4" />
              </video>)}
            </div>
            <div className="top-title"><img src="/cases/img/chateau/top_title.svg" alt="" /></div>
          </section>

          <section className="section2">
            <div className="main">
              <h1 className="title">Винодельня “Шато Ай-Даниль”</h1>
              <dl className="details">
                <div className="detail">
                  <dt>Клиент</dt>
                  <dd>Близкий берег</dd>
                </div>
                <div className="detail">
                  <dt>Виды работ</dt>
                  <dd>Платформа бренда</dd>
                  <dd>Сайт</dd>
                </div>
              </dl>
            </div>
            <div className="description">
              <p>Для&nbsp;винодельни «Шато Ай-Даниль» на&nbsp;Южном берегу Крыма мы&nbsp;разработали новую бренд-платформу и&nbsp;вместе с&nbsp;ней&nbsp;— сайт, вдохновлённый эстетикой больших европейских шато: сдержанной, кинематографичной, без&nbsp;единого лишнего элемента.</p>
            </div>
          </section>

          <section className="section3">
            <div>
              <img src="/cases/img/chateau/img2.webp" />
            </div>
          </section>

          <section className="section4">
            <div className="main">
              <h2 className="title">Концепция</h2>
            </div>
            <div className="description">
              <p>В&nbsp;основе сайта&nbsp;— сдержанность и&nbsp;выверенность. Информация подаётся деликатно: короткие смысловые блоки, много пространства вокруг текста, плавный ритм повествования вместо плотной информационной ленты. Сайт рассказывает о&nbsp;терруаре, истории шато и&nbsp;месте, где&nbsp;рождается вкус, оставляя ощущение высокого класса бренда без&nbsp;прямых заявлений о&nbsp;нём.</p>
            </div>
          </section>

          <section className="section5">
            <div>
              <img src="/cases/img/chateau/img3.webp" />
            </div>
            <div>
              <div className="img">
                <img src="/cases/img/chateau/img4.webp" />
              </div>
              <div className="video">
                <video src="/cases/img/chateau/video2.mp4" poster="/cases/img/chateau/new/video2_poster.webp" playsInline autoPlay muted loop />
                <div className="section5__title"><img src="/cases/img/chateau/section5_title.svg" alt="Летний зной смягчают освежающие морские ветры." /></div>
              </div>
            </div>
          </section>

          <section className="section6">
            <div className="wine-slider">
              <div>
                <img src="/cases/img/chateau/wine1.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine2.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine3.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine4.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine5.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine6.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine7.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine8.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine9.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine10.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine11.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine12.webp" />
              </div>
              <div>
                <img src="/cases/img/chateau/wine13.webp" />
              </div>
            </div>
          </section>

          <section className="section7">
            <div className="video">
              <video src="/cases/img/chateau/video3.mp4" poster="/cases/img/chateau/new/poster.webp" playsInline preload="metadata" onClick={this.handleVideoPause} onEnded={this.handleVideoEnded} />
            </div>
            <button className="play" type="button" aria-label="Play video" onClick={this.handleVideoPlay}>
              <img src="/cases/img/armani/new/play.svg" alt="" />
            </button>
          </section>

          <section className="section8">
            <div className="main">
              <h2 className="title">Дизайн</h2>
            </div>
            <div className="description">
              <p>Визуальный язык строится на&nbsp;крупных, почти документальных кадрах: виноградники, море, свет Южного берега. Приглушённая, землистая палитра, чистая типографика и&nbsp;минимальная навигация оставляют главную роль изображению и&nbsp;терруару, а&nbsp;не&nbsp;интерфейсу.</p>
            </div>
          </section>

          <section className="section9">
            <img src="/cases/img/chateau/img8.webp" />
          </section>

          <section className="section10">
            <div>
              <img src="/cases/img/chateau/img9_1.webp" />
            </div>
            <div>
              <img src="/cases/img/chateau/img9_2.webp" />
            </div>
          </section>

          <section className="section11">
            <div>
              <img src="/cases/img/chateau/img10_1.webp" />
            </div>
            <div>
              <img src="/cases/img/chateau/img10_2.webp" />
            </div>
          </section>

          <section className="section12">
            <div className="video">
              <video src="/cases/img/chateau/video3.mp4" poster="/cases/img/chateau/video3_poster.webp" playsInline preload="metadata" onClick={this.handleVideoPause} onEnded={this.handleVideoEnded} />
            </div>
            <button className="play" type="button" aria-label="Play video" onClick={this.handleVideoPlay}>
              <img src="/cases/img/armani/new/play.svg" alt="" />
            </button>
          </section>

          {/* <section className="section8">
            <div>
              <img src="/cases/img/armani/new/img10.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img11.webp" />
            </div>
          </section> */}

          {/* <section className="section9">
            <div className="video">
              <video src="/cases/img/armani/video.mp4" poster="/cases/img/armani/new/poster.webp" playsInline preload="metadata" onClick={this.handleVideoPause} onEnded={this.handleVideoEnded} />
            </div>
            <button className="play" type="button" aria-label="Play video" onClick={this.handleVideoPlay}>
              <img src="/cases/img/armani/new/play.svg" alt="" />
            </button>
          </section> */}

          {/* <section className="section10">
            <div>
              <div>
                <img src="/cases/img/armani/new/img12.webp" />
              </div>
            </div>
            <div>
              <div>
                <p>Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко&nbsp;всем необходимым функциям в&nbsp;любое время и&nbsp;в&nbsp;любом месте.</p>
                <p>Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и&nbsp;интуитивной. При&nbsp;этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и&nbsp;создавая гармоничное восприятие даже на&nbsp;небольших экранах.</p>
              </div>
            </div>
          </section> */}

          {/* <section className="section11">
            <div>
              <img src="/cases/img/armani/new/img13.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img14.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img15.webp" />
            </div>
            <div>
              <img src="/cases/img/armani/new/img16.webp" />
            </div>
          </section> */}
        </div>

        <CaseFooter 
          to={this.props.next ? this.props.next.url : "/projects/afimall/"}
          title={this.props.next ? this.props.next.name : "Афимолл Сити + Маша и Медведь"} 
          img={this.props.next ? this.props.next.imgCaseBottom : "/cases/img/next/afimall.webp"}
        />

        <HelmetSite title="Armani / Casa Эксклюзивные резиденции" />
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chateau)